import React from "react";
import { reportClientError } from "@/lib/api";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError(error, { path: window.location.pathname, componentStack: info.componentStack });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="flex min-h-screen items-center justify-center bg-ink px-5 text-center text-white">
        <div className="max-w-lg rounded-sm border border-white/10 bg-ink-2 p-8">
          <div className="text-3xl text-gold">&#9670;</div>
          <h1 className="mt-4 font-serif text-4xl font-light">We could not display this page</h1>
          <p className="mt-3 text-sm leading-relaxed text-white/60">
            The problem has been recorded. Reload the page, or return home and try again.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <button className="rounded-sm bg-gold px-5 py-3 text-xs uppercase tracking-widest text-ink" onClick={() => window.location.reload()}>
              Reload page
            </button>
            <a className="rounded-sm border border-gold px-5 py-3 text-xs uppercase tracking-widest text-gold" href="/">
              Return home
            </a>
          </div>
        </div>
      </main>
    );
  }
}
